import {
  Breadcrumb,
  Button,
  Col,
  Input,
  Modal,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { getRequest, postRequest } from "../../../axios";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import BulkUploadCsv from "../../../image/AddCsvFile.png";
import { ReactComponent as Archive } from "../../../image/Archive.svg";
import { ReactComponent as Archiveicon } from "../../../image/Archiveicon.svg";
import { ReactComponent as Editicon } from "../../../image/Editicon.svg";
import PlusSquareOutlined from "../../../image/PlusSquareOutlined.svg";
import SearchIcon from "../../../image/SearchIcon.svg";
import "../../../styles/Main.scss";
import { authUserData } from "../../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
import AddPincode from "./AddPincode";
import BulkPincodeUpload from "./BulkPincodeUpload";
const { Search } = Input;

const PincodeList = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pincodeList, setPincodeList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState([]);
  const [zoneList, setZoneList] = useState([]);
  const [reload, setReload] = useState(false);
  const [newPincodeAdded, setNewPincodeAdded] = useState(false);
  const [pincodeId, setPincodeId] = useState(null);
  const [modalKey, setModalKey] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [state, setState] = useState({
    page: 1,
    ordering: "-id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  // Fetch Pincode List API  
  useEffect(() => {
    const getPincodeList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest("pincode/", state);
        if (apiResponse.data.results.success) {
          setPincodeList(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_list_pincode"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getPincodeList();
  }, [state, newPincodeAdded, reload, t]);

  useEffect(() => {
    getZoneList();
  }, []);

  // Function to get Zone List 
  const getZoneList = async (data) => {
    await getRequest("zonename/?no_pagination=True", data).then((response) => {
      setZoneList(response.data.data);
    });
  };
 
  // Function To handle table change
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  // Function Of Shorting Enum Value
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "-id";

    if (sortField === "pincode_number" && sortOrder === "ascend") {
      sortingEnumKey = "pincode_number";
    }
    if (sortField === "pincode_number" && sortOrder === "descend") {
      sortingEnumKey = "-pincode_number";
    }
    if (sortField === "state_name" && sortOrder === "ascend") {
      sortingEnumKey = "state_name";
    }
    if (sortField === "state_name" && sortOrder === "descend") {
      sortingEnumKey = "-state_name";
    }
    if (sortField === "city_name" && sortOrder === "ascend") {
      sortingEnumKey = "city_name";
    }
    if (sortField === "city_name" && sortOrder === "descend") {
      sortingEnumKey = "-city_name";
    }

    if (sortField === "zone_name" && sortOrder === "ascend") {
      sortingEnumKey = "zone_id__zone_name";
    }
    if (sortField === "zone_name" && sortOrder === "descend") {
      sortingEnumKey = "-zone_id__zone_name";
    }

    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      page: 1,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
          (key) => !changeRows.find((row) => row.id === key)
        );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };
  const columns = [
    {
      title: "Pin Code",
      dataIndex: "pincode_number",
      key: "pincode_number",
      sorter: true,
    },
    {
      title: "City",
      dataIndex: "city_name",
      key: "city_name",
      sorter: true,
    },
    {
      title: "State",
      dataIndex: "state_name",
      key: "state_name",
      sorter: true,
    },
   
    {
      title: "Zone",
      dataIndex: "zone_name",
      key: "zone_name",
      sorter: true,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: "100px",
      render: (text, record) => (
        <Space>
          <Tooltip
            color={colors}
            placement="left"
            title={
              <span style={{ color: "#fff" }}>
                Edit
              </span>
            }
          >
            {authUserData()?.permission.includes("pincode|change_pincode") && (
              <Editicon onClick={() => handleUpdate(record.id)} style={{ cursor: "pointer" }} />
            )}
          </Tooltip>
          <Tooltip
            color={colors}
            placement="right"
            title={
              <span style={{ color: "#fff" }}>
                Archive
              </span>
            }
          >
          <Popconfirm
            className="action"
            title={t("pop_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleArchive(record.id)}
          >
            {authUserData()?.permission.includes("pincode|delete_pincode") && (
              <Archive style={{ cursor: "pointer" }} />
            )}
          </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];

  // function to update the ModalKey and PincodeId
  const handleUpdate = (id) => {
    setModalKey((prevKey) => !prevKey);
    setPincodeId(id);
    showModal();
  };

  // function to Add Pincode Id 
  const handleAdd = () => {
    setPincodeId(null);
    showModal();
    setReload((reload) => !reload);
  };

  // Function to Archive the the data
  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("pincode-delete/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids?.length;

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("pincode_archive_successfully"));

        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("error_in_delete_pincode"));
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [isModalOpenBulk, setIsModalOpenBulk] = useState(false);
  const showBulkUpload = () => {
    setIsModalOpenBulk(true);
  };
  const handleOkBulk = () => {
    setIsModalOpenBulk(false);
  };
  const handleCancelBulk = () => {
    setIsModalOpenBulk(false);
  };
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
          
              <h3>Pin Code</h3>
      

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("pincode")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
              <Search
  value={searchText}
  onChange={(e) => {
    const value = e.target.value;
    setSearchText(value);
    debounceLoadData(value, onSearch);
  }}
  allowClear
  onSearch={(value) => {
    setSearchText(value);
    onSearch(value);
  }}
  prefix={
    <img
      src={SearchIcon}
      alt="SearchIcon"
      className="SearchIcon"
      width={22}
    />
  }
  placeholder={t("pl_search_list")}
  style={{ width: 250 }}
/>

              </Space>
            </div>
            {authUserData()?.permission.includes("pincode|add_pincode") && (
              <Tooltip
                color={colors}
                placement="right"
                title={
                  <span style={{ color: "#fff" }}>
                    Add a new pin code and assign it to a specific zone or location.
                  </span>
                }
              >
                <Button
                  className="BlueShadowBtn"
                  type="primary"
                  onClick={handleAdd}
                  icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
                >
                  {t("pl_add_pincode")}
                </Button>
              </Tooltip>
            )}
            <Modal
              className="ModelPopupSec"
              title={pincodeId ? t("Edit Pin Code") : t("Add Pin Code")}
              open={isModalOpen}
              onOk={handleOk}
              onCancel={handleCancel}
              closable={false}
              wrapClassName="modal-wrapper"
              keyboard={false}
              
            >
              <AddPincode
                zoneList={zoneList}
                reload={reload}
                setReload={setReload}
                handleCancel={handleCancel}
                pincodeId={pincodeId}
                modalKey={modalKey}
                setStateM = {setState}
              />
            </Modal>

            <Modal
              className="ModelPopupSec"
              title="Upload File"
              open={isModalOpenBulk}
              onOk={handleOkBulk}
              onCancel={handleCancelBulk}
              closable={false}
              wrapClassName="modal-wrapper"
            >
              <BulkPincodeUpload
                setNewPincodeAdded={setNewPincodeAdded}
                newPincodeAdded={newPincodeAdded}
                pincodeId={pincodeId}
                handleCancelBulk={handleCancelBulk}
              />
            </Modal>

            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleArchive()}
              >
                {authUserData()?.permission.includes(
                  "pincode|delete_pincode"
                ) && (
                    <ButtonField
                      className="BlueShadowBtn"
                      type="primary"
                      htmlType="button"
                      label="Archive"
                    />
                  )}
              </Popconfirm>
            )}

            <Tooltip placement="topLeft" title="View Archived Records">
              <Link className="Archiveicon" to="/pincode/archive">
                <Archiveicon />
              </Link>
            </Tooltip>
            <Tooltip placement="topLeft" title="Bulk Upload">
              <Link className="BulkFileUplodIcon" onClick={showBulkUpload}>
                <img src={BulkUploadCsv} alt="" />
              </Link>
            </Tooltip>
          </Space>
        </div>
      </div>
      <section className="grid-sec tablegridsec">
        <div className="PR-body">
          <Row className="tblheader">
            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-action">
            </Col>
          </Row>
 <div className="tablewrp">
          <Table
            rowSelection={rowSelection}
            rowKey={(record) => record.id}
            columns={columns}
            dataSource={pincodeList}
            scroll={{ x: 800 }}
            loading={loading}
            pagination={{
              current: state.page,
              pageSize: state.pagesize,
              total: totalCount,
              showSizeChanger: true,
              showTotal: (totalCount) => `Total ${totalCount} items`,
              locale: {
                items_per_page: 'Items / Page', // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
</div>
        </div>
      </section>
    </>
  );
};

export default PincodeList;
